import Vue from 'vue'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    GET_DISCORD_ROLES: ({ rootState }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(
            `/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/discord/roles`,
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    GET_DISCORD_CHANNELS: ({ rootState }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(
            `/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/discord/channels`,
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),

    // ROLES
    GET_ROLES: ({ rootState }, { type }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(
            `/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/roles?type=${type}`,
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    ADD_ROLE: ({ rootState }, role) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post(
            `/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/roles`,
            role,
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    DELETE_ROLE: ({ rootState }, { role }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .delete(
            `/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/roles/${role.id}`,
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),

    // SECTORS
    GET_SECTORS: ({ rootState }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(`/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/sectors`)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    ADD_SECTOR: ({ rootState }, sector) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post(
            `/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/sectors`,
            sector,
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    UPDATE_SECTOR: ({ rootState }, { sector }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .put(
            `/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/sectors/${sector.id}`,
            sector,
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    DELETE_SECTOR: ({ rootState }, { sector }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .delete(
            `/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/sectors/${sector.id}`,
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),

    // STATUSES
    GET_STATUSES: ({ rootState }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(
            `/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/statuses`,
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    ADD_STATUS: ({ rootState }, status) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post(
            `/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/statuses`,
            status,
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    UPDATE_STATUS: ({ rootState }, { status }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .put(
            `/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/statuses/${status.id}`,
            status,
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    DELETE_STATUS: ({ rootState }, { status }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .delete(
            `/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/statuses/${status.id}`,
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    UPDATE_SERVICE: ({ rootState, commit }, { service }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .patch(
            `/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/settings`,
            service,
          )
          .then(res => {
            commit('selection/selectService', res.data, { root: true })

            resolve(res)
          })
          .catch(err => reject(err))
      }),
    DELETE_SERVICE: ({ rootState }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .delete(`/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}`)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    GET_TRANSFER_CODE: ({ rootState }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(
            `/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/transfer-code`,
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    GENERATE_TRANSFER_CODE: ({ rootState }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post(
            `/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/transfer-code`,
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    DELETE_TRANSFER_CODE: ({ rootState }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .delete(
            `/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/transfer-code`,
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    GET_SHOWN_SERVICES: ({ rootState }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(
            `/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/shown-services`,
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    ADD_SHOWN_SERVICE: ({ rootState }, { service, showOrder }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post(
            `/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/shown-services`,
            { serviceId: service.id, showOrder },
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    DELETE_SHOWN_SERVICE: ({ rootState }, { service }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .delete(
            `/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/shown-services/${service.id}`,
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    GET_ALL_SERVICES: ({ rootState }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(`/v1/communities/${rootState.selection.community.id}/services?all=true&onlyActive=true`)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    FETCH_SERVICE_DISCORD: ({ rootState }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(`/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/guild`)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    FETCH_SUBSCRIPTION: ({ rootState }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(
            `/v1/communities/${rootState.selection.community.id}/subscription/services/${rootState.selection.service.id}`,
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    UPDATE_SUBSCRIPTION: ({ rootState }, { services, isPreview = true }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .put(
            `/v1/communities/${rootState.selection.community.id}/subscription/services/${rootState.selection.service.id}`,
            { services, isPreview },
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    PAUSE_SUBSCRIPTION: ({ rootState }, { pause }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post(
            `/v1/communities/${rootState.selection.community.id}/subscription/services/${rootState.selection.service.id}/pause`,
            { pause },
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    CANCEL_SUBSCRIPTION: ({ rootState }, { cancelReason, cancelReasonDetails }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post(
            `/v1/communities/${rootState.selection.community.id}/subscription/services/${rootState.selection.service.id}/cancel`,
            { cancelReason, cancelReasonDetails },
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    FETCH_SUBSCRIPTION_TRANSACTIONS: ({ rootState }, { startDate, endDate, pageNumber, pageSize }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(
            `/v1/communities/${rootState.selection.community.id}/subscription/services/${rootState.selection.service.id}/transactions?startDate=${startDate}&endDate=${endDate}&pageNumber=${pageNumber}&pageSize=${pageSize}`,
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
  },
}
